const defaultTheme = require('tailwindcss/defaultTheme');

/** @type {import('tailwindcss').Config} */
function tailwindConfig(options = {}) {

    return {
        content: [
            'views/*.blade.php',
            'views/**/*.blade.php',
            'javascript/*.js',
            'javascript/**/*.js',
            'js/*.vue',
            'js/**/*.vue',
        ],
        safelist: [
            'lg:columns-2',
            'lg:gap-x-32',
            'min-h-full-passe',
            'max-w-sm',
            'bg-fixed',

            'prose',
            'prose-invert',
            'lg:prose-lg',

            'lg:text-7xl',
            'text-5xl',

            'lg:px-4',
            'pt-10',

            'mx-auto',
            'my-auto',
            'lg:pt-32',
            '!mt-0',
            '!my-0',
            '!mb-4',
            'mt-7',
            'ml-4',
            'mb-4',
            'mb-36',
            'py-7',
            'py-24',
            'lg:px-20',

            'content-end',

            'lg:grid-cols-12',

            'lg:col-start-2',
            'lg:col-start-3',
            'lg:col-start-7',

            'lg:col-span-4',
            'lg:col-span-3',
            'lg:col-span-10',

            'basis-28',
            'place-items-center',
            'aspect-video',
            'divide-y',
            'divide-white',
            'max-w-4xl',
            'max-w-6xl',
            'max-w-7xl',
            '!max-h-clip-passe',
            '!min-h-clip-passe',

            'w-25',
            'w-50',
            'w-75',
            'w-100',
        ],
        theme: {
            screens: {
                'sm': '640px',
                'md': '768px',
                'lg': '1024px',
                'xl': '1280px',
                '2xl': '1680px',
            },
            container: {
                center: true,
                padding: '1rem',
            },

            extend: {
                colors: {
                    'primary': {
                        DEFAULT: '#DD1918',
                        500: '#DD1918',
                    },
                },
                fontFamily: {
                    sans: ['FlandersArtSans', ...defaultTheme.fontFamily.sans],
                },
                fontSize: {
                    xxs: ['11px', '28px'],
                    sm: ['14px', '28px'],
                    base: ['16px', '28px'],
                    lg: ['20px', '28px'],
                    xl: ['24px', '28px'],
                },
                spacing: {
                    'full-passe': 'calc(100vh - var(--header-height) - var(--footer-height))',
                    'header-height': 'var(--header-height)',
                    'footer-height': 'var(--footer-height)',
                    'clip': 'var(--opposite)',
                    'clip-passe': 'calc(var(--full-passe) + var(--opposite))',
                },
                maxWidth: {
                    'full-passe': 'calc(100%-40px)',
                },
                minHeight: {
                    'full-passe': 'calc(100vh - var(--header-height) - var(--footer-height))',
                    'clip-passe': 'calc(var(--full-passe) + var(--opposite))',
                },
                maxHeight: {
                    'clip-passe': 'calc(var(--full-passe) + var(--opposite))',
                    'full-passe': 'calc(100vh - var(--header-height) - var(--footer-height))',
                },
                lineHeight: {
                    '11': '2.75rem',
                    '12': '3rem',
                },
                width: {
                    '25': '25%',
                    '50': '50%',
                    '75': '75%',
                    '100': '100%',
                },
                typography: (theme) => ({
                    DEFAULT: {
                        css: getDefault(theme, {
                            // standaard
                            '--tw-prose-headings': theme('colors.primary.500'),
                            '--tw-prose-links': theme('colors.primary.500'),
                            '--tw-prose-body': theme('colors.black'),
                            '--tw-prose-quotes': theme('colors.primary.500'),

                            // inverse
                            '--tw-prose-invert-headings': theme('colors.white'),
                            '--tw-prose-invert-body': theme('colors.white'),
                            '--tw-prose-invert-quotes': theme('colors.white'),
                            '--tw-prose-invert-links': theme('colors.white'),
                            '--tw-prose-invert-bullets': theme('colors.white'),
                        }),
                    },
                    lg: {
                        css: getDefault(theme),
                    },
                }),
            },
        },
        plugins: [
            'postcss-import',
            'tailwindcss',
            'autoprefixer',
            require('@tailwindcss/forms')({
                strategy: 'base',
            }),
            require('@tailwindcss/typography'),
        ],

        ...options,
    };
}

function getDefault(theme, options = {}) {
    return {
        ...options,

        lineHeight: '28px',

        'h2': {
            fontWeight: theme('fontWeight.bold'),
            fontSize: theme('fontSize.3xl.0'),
            marginBottom: theme('spacing.4'),
        },
        'a': {
            '&:hover': {
                color: theme('colors.black'),
                cursor: theme('cursor.pointer'),
            },
            textDecoration: 'no-underline',
        },
        'blockquote': {
            paddingLeft: 0,
            borderLeft: 0,
            fontStyle: 'normal',
            fontWeight: theme('fontWeight.normal'),
        },
        'span': {
            color: 'var(--tw-prose-headings)',
            fontSize: theme('fontSize.base.0'),
        },
        'figcaption': {
            color: theme('colors.primary.500'),
            fontSize: theme('fontSize.base.0'),
        },

        maxWidth: theme('maxWidth.7xl'),
        marginInline: 'auto',
    };
};

module.exports = tailwindConfig;